export default "__VITE_ASSET__BtWzZQPA__"